import React from 'react';
import { ButtonOverlayIcon } from '../../../base/buttons';

const ButtonEdit = ({ 
  cmpId = 'btn-edit',
  iconName = 'pencil-alt',
  iconSize,
  tooltipLabel = 'Edit',
  bsSize = 'xsmall',
  bsStyle = 'warning',
  className,
  onClick
}) => {
  return (
    <ButtonOverlayIcon
      cmpId={cmpId}
      className={className}
      iconName={iconName}
      iconSize={iconSize}
      tooltipLabel={tooltipLabel}
      bsStyle={bsStyle}
      bsSize={bsSize}
      onClick={onClick}
    />
  );
};

export default ButtonEdit;
